import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import AlertType from 'models/enums/AlertType';

const defaultClaimAlert: Model.IClaimAlert = {
  type: AlertType.info,
  title: '',
  message: '',
};

function parseClaimAlertValue(value?: string | null): Model.IClaimAlert {
  if (!value) return { ...defaultClaimAlert };

  try {
    const parsed = JSON.parse(value);
    if (!parsed || typeof parsed !== 'object') return { ...defaultClaimAlert };

    return {
      type: Object.values(AlertType).includes(parsed.type) ? parsed.type : AlertType.info,
      title: parsed.title?.toString?.() ?? '',
      message: parsed.message?.toString?.() ?? '',
    };
  } catch {
    return { ...defaultClaimAlert };
  }
}

export default function AutomationClaimAlertModal(props: {
  value?: string | null;
  onSave(value: string): void;
  onCancel(): void;
}) {
  const { lang, translate } = getLocales();

  return (
    <ModalForm<Model.IClaimAlert>
      title={lang.claimAlert}
      subcomponents={ThemeModalFormDefault}
      onCancel={props.onCancel}
      default={parseClaimAlertValue(props.value)}
      submitButtonText={lang.save}
      validation={(data, errors) => {
        if (!data?.type) errors.type = lang.required;
        if (!data?.title) errors.title = lang.required;
        if (!data?.message) errors.message = lang.required;
      }}
      onSubmit={(data) =>
        props.onSave(
          JSON.stringify({
            type: data.type,
            title: data.title,
            message: data.message,
          })
        )
      }
      render={({ form }) => (
        <FormWrapper>
          <SelectInput
            name="type"
            label={lang.type}
            data={Object.values(AlertType).map((type) => ({
              id: type,
              title: translate(type),
            }))}
            value={form.data?.type}
            error={form.errors?.type}
            onChange={({ type }) => form.update({ type })}
          />
          <TextInput
            name="title"
            label={lang.title}
            value={form.data?.title}
            error={form.errors?.title}
            onChange={({ title }) => form.update({ title })}
          />
          <MultilineTextInput
            name="message"
            label={lang.message}
            value={form.data?.message}
            error={form.errors?.message}
            onChange={({ message }) => form.update({ message })}
          />
        </FormWrapper>
      )}
    />
  );
}
